import MobileInput from '@/common/components/base/input/mobileInput/MobileInput';
import { FreeZonePlateValue } from '@/common/components/base/input/plate/freeZonePlateInput/freeZonePlateInput.type';
import { plateValue } from '@/common/components/base/input/plate/vehiclePlateInput/vehiclePlateInput.type';
import TextInput from '@/common/components/base/input/textInput/TextInput';
import { PERSIAN_LATTER_RULE } from '@/common/components/base/input/textInput/textInput.rules';
import PlateSelection from '@/common/components/plateSelection/PlateSelection';
import { requiredText } from '@/common/utils/rules/publicRules';
import { useFormContext, useWatch } from 'react-hook-form';
import { Box } from 'styled-system/jsx';

const AddDamagedVehicleLegalForm = () => {
  const methods = useFormContext();
  const formData = useWatch({ control: methods.control });

  return (
    <Box mt="1rem">
      <TextInput
        label="نام"
        name="name"
        placeholder="نام را وارد کنید"
        rules={{ required: requiredText, ...PERSIAN_LATTER_RULE }}
      />

      <PlateSelection
        plateDesign={formData.vehicle_plate_design?.value}
        onChangeFunctions={{
          freeZonePlateOnChange: (value) => {
            methods.setValue('plate', value);
          },
          plateDesignOnChange: () => {},
        }}
        values={{
          plate:
            formData.vehicle_plate_design?.value === 'county'
              ? (formData.plate as plateValue)
              : (formData.plate as FreeZonePlateValue),
        }}
        vehiclePlateType={formData?.vehicle_type}
        plateDesignName="vehicle_plate_design"
      />

      <Box mt="1.5rem">
        <MobileInput name="phone_number" />
      </Box>
    </Box>
  );
};

export default AddDamagedVehicleLegalForm;
